import type { FC } from 'react'
import { Trans } from 'react-i18next'
import { Box, type Sx } from '@dhl/theme'
import { ParcelCatInTheBox } from '@dhl/illustrations'
import { viewportHeightCssVariable } from '@dhl/viewport-height'
import { Body1 } from '@dhl-ui/components'
import { useSearchStore } from '~/search/model/useSearchStore.js'

const classes: Record<string, Sx> = {
  container: (theme) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    textAlign: 'center',
    [theme.breakpoints.down('xl')]: {
      height: [`calc((${viewportHeightCssVariable} * 100) - 130px)`, '-webkit-fill-available'],
    },
    [theme.breakpoints.up('md')]: {
      minHeight: 'inherit',
    },
    [theme.breakpoints.down('md')]: {
      justifyContent: 'flex-start',
    },
  }),
  svg: {
    maxWidth: '80vw',
    width: '300px',
    height: '150px',
  },
}

export const NoSearchResults: FC = () => {
  const { searchTerm } = useSearchStore()

  return (
    <Box data-test="search-no-results" sx={classes.container}>
      <ParcelCatInTheBox sx={classes.svg} />

      <Box mt={2}>
        <Body1>
          <Trans i18nKey="portal.search.noResults.title" values={{ searchTerm }} components={{ strong: <strong /> }} />
        </Body1>
      </Box>
    </Box>
  )
}
